/**
 * YouTube's optional second template (2026-10-08). A brand's assignments for
 * one platform and orientation are a "main" row and, for YouTube only, an
 * optional "second" row; one of them is the default the editor opens on.
 *
 * Rows from before this existed carry no `slot` / `is_default`: they read as
 * main and default, so a brand without a second template is unchanged.
 */

/** Platforms that may have a second template (mirrors the backend rule). */
export const SECOND_SLOT_PLATFORMS = ["YOUTUBE"];

export const slotOf = (row) => row?.slot || "main";

/** `{ main, second, default }` rows for one platform and orientation (any may be null). */
export function templateSlots(rows, platform, orientation = "vertical") {
  const list = (rows || []).filter((t) => t.platform === platform && t.orientation === (orientation || "vertical"));
  const main = list.find((t) => slotOf(t) === "main") || null;
  const second = list.find((t) => slotOf(t) === "second") || null;
  const def = [main, second].find((t) => t && t.is_default !== false) || main || second;
  return { main, second, default: def };
}

/** Both orientations' slots, or null when the platform has no second template anywhere. */
export function templateChoices(rows, platform) {
  const vertical = templateSlots(rows, platform, "vertical");
  const horizontal = templateSlots(rows, platform, "horizontal");
  if (!vertical.second && !horizontal.second) return null;
  return { vertical, horizontal };
}

/**
 * The main/second pair a switch offers for the template open now: the
 * orientation whose main or second row it is, else vertical. Null when that
 * orientation has no second template.
 */
export function pairFor(choices, templateId) {
  if (!choices) return null;
  const id = templateId == null ? null : String(templateId);
  const has = (slots) => [slots.main, slots.second].some((r) => r && String(r.template_id) === id);
  const slots = has(choices.horizontal) ? choices.horizontal : choices.vertical;
  return slots.main && slots.second ? slots : null;
}
